import { gql } from '@apollo/client';

export const GET_PRODUCTS = gql`
  query products(
    $params: QueryParams
    $name: String
    $type: String
    $excludeTypes: [String]
  ) {
    products(
      params: $params
      name: $name
      type: $type
      excludeTypes: $excludeTypes
    ) {
      results {
        id
        name
        description
        recommendedProduct
        categories {
          id
          category {
            name
            description
            img
            priority
          }
        }
        variants {
          id
          title
          img
          description
          price
          isPrimaryVariant
          product {
            name
            description
          }
        }
        type
        rulesAdditionals {
          requireComplements
          maxComplements
          complementItems {
            id
            title
            img
            description
            price
            product {
              id
              name
              description
            }        
          }
          requireBeverages
          maxBeverages
          beverageItems {
            id
            title
            img
            description
            price
            product {
              id
              name
              description
            }  
          }
          includesExtras
          extraRules {
            product {
              id
              name
              description
              type
            }
            max
            required
          }
        }
      }
      info {
        count
        prev
        next
        pages
      }
    }
  }
`;
